var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 19.43c-.71-.63-1-.75-2.14.07-.5.37-1.06.88-1.51 1.23C1.65 17 1.8 18.28 3 8c0-.2.36-1.21.13-1.35.23-.39-.46-.82-.64-.16s.27-1-.87 5.15C1.46 12.83-.24 20.34 0 21.6a.66.66 0 0 0 .32.47c.74.42 1.6-.69 2.62-1.58a3.21 3.21 0 0 1 .88-.66.27.27 0 0 1 .12.06c2.24 1.64 2.55 2.74 3 2.79a.35.35 0 0 0 .37-.32c.11-.42-2.16-2.61-2.51-2.93Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.19c.51.09.64-1.73.7-1.89a5.59 5.59 0 0 1 1-1.65c1.74-2.09 3-.49 3.18-.61.28.45 1.28-.11 0-.89a2.85 2.85 0 0 0-2-.51C6.83 1 6 2.33 5.57 4c-.14.68-.49 2.13.18 2.19Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.71 7a.84.84 0 0 0-.48-.55A11.73 11.73 0 0 0 18.46 6a6.75 6.75 0 0 0-1.14-3.14c-1.59-2.2-4.54-2-5.61-.12a10.44 10.44 0 0 0-.86 3.36c-1 0-3.31.06-3.53.32s0 2.68 0 3.31C7.24 12.45 8 22.37 8 22.45c.12.62.41.67 1 .73.86.09 4.71.28 6.07.2.65 0 1.3-.11 1.95-.18 1-.11 3 .12 4.52 0 .76-.08 2.17-.38 2.35-1.12.31-1.02-.49-13.15-1.18-15.08Zm-10-3.71A2.11 2.11 0 0 1 15 2.53c1.43.28 2.33 2.06 2.6 3.5a36.32 36.32 0 0 1-5.83.11 9.47 9.47 0 0 1 .9-2.82Zm10.11 18.35c-1.09.7-4.58.28-5.87.44a21.89 21.89 0 0 1-3.13.25c-4.89-.07-4.84.15-4.92-1-.75-8.75-.9-10-.9-11.58l0-2.86c1 0 2-.07 2.66 0-.35 2.07-.36 2.23-.3 2.35a.41.41 0 0 0 .33.26c.44.06.28-.23.78-2.56a38.87 38.87 0 0 0 6.18 0c.38 2.18.34 2.4.52 2.53a.32.32 0 0 0 .43 0A9.08 9.08 0 0 0 18.56 7a11.86 11.86 0 0 1 3.12.43c0 .1.13.3.17.49a128.16 128.16 0 0 1 .97 13.72Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.42 6.29-2 .11c-1.17.18-.77.52-.59.56A17.4 17.4 0 0 0 6.42 7c.78-.25.72-.48 0-.71Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.51d07f171bea57d7fd0b365e16e76d6b.svg";
export { ForwardRef as ReactComponent };